module.exports = __webpack_public_path__ + "img/mouvement_desjardins.5c00774c.webp";